// extracted by mini-css-extract-plugin
export default {"icono":"EncuestasCardHome_icono__jKA6d","cardBg":"EncuestasCardHome_cardBg__Quc0Y"};